module.exports = __webpack_public_path__ + "img/lg_ring_g_0_null_0.4de1de1b.png";